import React from 'react';
import { CFProgressIndicatorElements } from './ProgressIndicator.styles';
export const CFProgressIndicatorItem = ({ alternateTheme = false, isCurrent = false, disabled = false, shape = 'pills', variant = 'default', }) => {
    const { Item } = CFProgressIndicatorElements;
    return (React.createElement(Item, { alternateTheme: alternateTheme, role: 'presentation', disabled: disabled, isCurrent: isCurrent && !disabled, shape: shape, variant: variant }));
};
